import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";

const DeliveryTimeChart = ({ data, shipmentSummary }) => {
  const hasDeliveryTime = data.some((row) => Number(row.days) > 0);
  const totalShipments = Number(shipmentSummary?.shipments) || 0;
  const delivered = Number(shipmentSummary?.delivered) || 0;
  const inTransit = Number(shipmentSummary?.inTransit) || 0;
  const rto = Number(shipmentSummary?.rto) || 0;
  const chartData = hasDeliveryTime
    ? data
    : [
        { courier: "Delivered", value: delivered },
        { courier: "In Transit", value: inTransit },
        { courier: "RTO", value: rto },
        { courier: "Pending", value: Math.max(totalShipments - delivered - inTransit - rto, 0) },
      ];
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">
          {hasDeliveryTime ? "Average Delivery Time" : "Shipment Status Overview"}
        </h5>
      </div>

      <div className="card-body">
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="courier" />

            <YAxis
              domain={[0, (max) => Math.max(max, 1)]}
              label={{
                value: hasDeliveryTime ? "Days" : "Shipments",
                angle: -90,
                position: "insideLeft",
              }}
            />

            <Tooltip formatter={(value) => hasDeliveryTime ? `${value} days` : `${value} shipments`} />

            <Bar dataKey={hasDeliveryTime ? "days" : "value"} fill="#6f42c1" radius={[5, 5, 0, 0]}>
              <LabelList
                dataKey={hasDeliveryTime ? "days" : "value"}
                position="top"
                formatter={(value) => `${value} ${hasDeliveryTime ? "days" : "shipments"}`}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DeliveryTimeChart;
